<template>
  <div>
    <div class="banner">
      <p class="p1">可借额度</p>
      <p class="p2">￥{{money}} <span>元</span></p>
      <p class="p3">年利率{{lilv}}</p>
      <p class="p4">恭喜您！申请成功！快去借款吧~</p>
    </div>
    <div class="lc">
      <div class="list">
        <span>1</span>
        <p>提交成功</p>
      </div>
      <div class="list">
        <span>2</span>
        <p>审核通过</p>
      </div>
      <div class="list">
        <span>3</span>
        <p>获取授权</p>
      </div>
      <div class="list">
        <span>4</span>
        <p>提现</p>
      </div>
    </div>
    <div class="btnSubmit">
      <van-button round block type="info" @click="nextFn">去面签</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      code: window.localStorage.getItem('code'),
      money: '0.00',
      lilv: '0%',
    }

  },
  mounted() {
    this.api.get_info({
      code: this.code
    }).then(res => {
      if (res.code == '1') {
        this.money = res.data.money;
        this.lilv = res.data.rate + '%';
        window.localStorage.setItem('money', this.money);
        window.localStorage.setItem('lilv', this.lilv);
      }
    })
  },
  methods: {
    // this.$router.push('/examine/audio')
    nextFn() {
      this.$router.push('/examine/audio')
    }
  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100vw;
  height: 200px;
  background: #2c64d4;

  p {
    margin: 0;
    text-align: center;
    color: #fff;
  }

  .p1,
  .p3,
  .p4 {
    font-size: 14px;
    padding-top: 15px;
  }

  .p2 {
    // font-weight: bold;
    font-size: 34px;
    margin-top: 25px;
  }
}

.lc {
  display: flex;
  font-size: 14px;
  margin-bottom: 20px;
  padding-right: 20px;
  background: #fff;
  padding: 40px 0px;
  margin-top: 20px;

  .list {
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;

    span {
      text-align: center;
      width: 30px;
      height: 30px;
      border-radius: 30px;
      line-height: 30px;
      text-align: center;
      background: #2c64d4;
      color: #fff;
      margin-bottom: 6px;
      position: relative;
      display: block;

      &::before {
        content: '';
        display: block;
        width: 50px;
        height: 3px;
        position: absolute;
        right: 35px;
        top: 14px;
        background: #ddd;
      }
    }

    p {
      margin: 0px 0px;
      color: #686868;
    }

    &:first-child {
      span {
        &::before {
          display: none;
        }
      }
    }
  }
}
</style>
